export var FieldType;
(function (FieldType) {
    FieldType["YES_NO"] = "yesNo";
    FieldType["FREE_TEXT"] = "freeText";
    FieldType["SELECT"] = "select";
    FieldType["NUMBER"] = "number";
})(FieldType || (FieldType = {}));
export var ActionType;
(function (ActionType) {
    ActionType["FOLLOW_UP"] = "followUp";
    ActionType["PASS"] = "pass";
    ActionType["FAIL"] = "fail";
})(ActionType || (ActionType = {}));
export var ComparisonType;
(function (ComparisonType) {
    ComparisonType["EQUAL"] = "equal";
    ComparisonType["RANGE"] = "range";
    ComparisonType["INFERIOR"] = "inferior";
    ComparisonType["SUPERIOR"] = "superior";
    ComparisonType["INFERIOR_EQUAL"] = "inferiorEqual";
    ComparisonType["SUPERIOR_EQUAL"] = "superiorEqual";
})(ComparisonType || (ComparisonType = {}));
//# sourceMappingURL=form.js.map